import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchEmployees, deleteEmployee, disableEmployee, enableEmployee } from "../../redux/employeeSlice";
import styles from "./Employees.module.css";

export default function Employees() {
  const dispatch = useDispatch();
  const { employees, loading } = useSelector((state) => state.employees);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const handleDelete = async (id, name) => {
    setError("");
    if (!window.confirm(`Are you sure you want to delete ${name}?`)) return;
    try {
      await dispatch(deleteEmployee(id)).unwrap();
    } catch (err) {
      setError(err || "Failed to delete employee");
    }
  };

  const handleDisable = async (id, name, currentStatus) => {
    setError("");
    const action = currentStatus === "disabled" ? enableEmployee : disableEmployee;
    const actionLabel = currentStatus === "disabled" ? "enable" : "disable";
    if (!window.confirm(`Are you sure you want to ${actionLabel} ${name}?`)) return;
    try {
      await dispatch(action(id)).unwrap();
    } catch (err) {
      setError(err || `Failed to ${actionLabel} employee`);
    }
  };

  return (
    <div className={styles.employeesPage}>
      <div className={styles.header}>
        <div>
          <h1>Employees</h1>
          <p>Manage all employee accounts</p>
        </div>
        <Link to="/admin/create-employee" className={styles.createBtn}>
          + Create Employee
        </Link>
      </div>

      <div className={styles.tableWrap}>
        {error && <div className={styles.alertError}>{error}</div>}
        {loading && employees.length === 0 ? (
          <div className={styles.empty}>Loading employees...</div>
        ) : employees.length === 0 ? (
          <div className={styles.empty}>No employees found.</div>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Department</th>
                <th>Designation</th>
                <th>Employee ID</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp.id}>
                  <td>{emp.name}</td>
                  <td>{emp.email}</td>
                  <td>{emp.department}</td>
                  <td>{emp.designation}</td>
                  <td>{emp.employeeId}</td>
                  <td>
                    <span className={`${styles.badge} ${styles[emp.status]}`}>
                      {emp.status}
                    </span>
                  </td>
                  <td className={styles.actions}>
                    <Link to={`/admin/edit-employee/${emp.id}`} className={styles.editBtn}>
                      Edit
                    </Link>
                    <button
                      className={styles.disableBtn}
                      onClick={() => handleDisable(emp.id, emp.name, emp.status)}
                    >
                      {emp.status === "disabled" ? "Enable" : "Disable"}
                    </button>
                    <button
                      className={styles.deleteBtn}
                      onClick={() => handleDelete(emp.id, emp.name)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
